import { CompleteDialog } from "./components/CompleteDialog";

export default CompleteDialog;